import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb83b278"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-2 mt-4" }
const _hoisted_2 = {
  class: "mb-5 pb-4 border shadow-lg border-primary-50 text-white dark:text-dark-text dark:bg-dark-800 dark:border-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons mr-2" }, "label", -1))
const _hoisted_4 = {
  key: 0,
  class: "mt-3 ml-3"
}
const _hoisted_5 = { class: "grid grid-cols-2" }
const _hoisted_6 = {
  class: "mb-5 pb-4 mr-2 border shadow-lg border-primary-50 text-white dark:text-dark-text dark:bg-dark-800 dark:border-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons mr-2" }, "label", -1))
const _hoisted_8 = {
  key: 0,
  class: "mt-3 ml-3"
}
const _hoisted_9 = {
  class: "mb-5 pb-4 ml-2 border shadow-lg border-primary-50 text-white dark:text-dark-text dark:bg-dark-800 dark:border-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons mr-2" }, "label", -1))
const _hoisted_11 = {
  key: 0,
  class: "mt-3 ml-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueApexCharts = _resolveComponent("VueApexCharts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex text-lg bg-primary-500 border-primary-50 dark:bg-dark-400 dark:border-dark-700", _ctx.isLightMode() ? 'top' : 'top-dark']),
        style: {"border-top-right-radius":"1rem","border-top-left-radius":"1rem"}
      }, [
        _hoisted_3,
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('message.problemCategory')), 1)
      ], 2),
      (_ctx.series.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('message.noData')), 1))
        : (_openBlock(), _createBlock(_component_VueApexCharts, {
            key: 1,
            class: "mt-2",
            height: "450",
            options: _ctx.nested.chartOptions.value,
            series: _ctx.series,
            type: "pie"
          }, null, 8, ["options", "series"]))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex text-lg bg-primary-500 border-primary-50 dark:bg-dark-400 dark:border-dark-700", _ctx.isLightMode() ? 'top' : 'top-dark']),
          style: {"border-top-right-radius":"1rem","border-top-left-radius":"1rem"}
        }, [
          _hoisted_7,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('message.userSubmissions')), 1)
        ], 2),
        (_ctx.seriesStatus.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('message.noData')), 1))
          : (_openBlock(), _createBlock(_component_VueApexCharts, {
              key: 1,
              class: "mt-2",
              height: "450",
              options: _ctx.nested.chartOptionsStatus.value,
              series: _ctx.seriesStatus,
              type: "pie"
            }, null, 8, ["options", "series"]))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex text-lg bg-primary-500 border-primary-50 dark:bg-dark-400 dark:border-dark-700", _ctx.isLightMode() ? 'top' : 'top-dark']),
          style: {"border-top-right-radius":"1rem","border-top-left-radius":"1rem"}
        }, [
          _hoisted_10,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('message.languageSubmissions')), 1)
        ], 2),
        (_ctx.seriesLanguage.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('message.noData')), 1))
          : (_openBlock(), _createBlock(_component_VueApexCharts, {
              key: 1,
              class: "mt-2",
              height: "450",
              options: _ctx.nested.chartOptionsLanguage.value,
              series: _ctx.seriesLanguage,
              type: "pie"
            }, null, 8, ["options", "series"]))
      ])
    ])
  ]))
}